


export const CREATE_ARCSUPPORTTICKETS = "CREATE_ARCSUPPORTTICKETS";   
export const RETRIEVE_ARCSUPPORTTICKETS = "RETRIEVE_ARCSUPPORTTICKETS";
export const RETRIEVESINGLE_ARCSUPPORTTICKETS = "RETRIEVESINGLE_ARCSUPPORTTICKETS";
export const UPDATE_ARCSUPPORTTICKETS = "UPDATE_ARCSUPPORTTICKETS";   
export const DELETE_ARCSUPPORTTICKETS = "DELETE_ARCSUPPORTTICKETS";  